<style scoped>
.map-fields-name-action sup {
  color: #ff0000;
  font-size: 14px !important;
}

.map-fields-name-action-input sup {
  color: #ff0000;
  font-size: 14px !important;
}

.action-tab-select-down {
  text-align: left;
}

.workflow-map-fields {
  width: 100%;
}

.map-fields-name {
  width: 100% !important;
}

.action-dropdown-toggle {
  background: none;
  border: none;
  font-weight: 400;
  color: #00a8ff;
  padding: 2px;
  font-size: 12px;
}

.map-fields-name-action {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
}

.map-fields-name-action-input {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
  margin-top: 16px;
}

.workflow-map-fields-items a:after {
  content: none;
}

.action-tab-select-down-menu ul li a {
  margin-left: 0;
  padding-left: 10px;
}

.action-tab-select-down-menu {
  width: 200px;
}

.action-dropdown-toggle::after {
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-left: 5px;
}

.wf-task-tab-content a:after {
  content: none;
}

.send-mail-inputs {
  margin-top: 0;
  height: auto;
  padding: 2px 0px;
  width: 100%;
}

.workflow-tab-select-table {
  text-align: left;
  padding: 0 25px;
  margin-left: 16.5%;
}

.workflow-crete-set-field {
  margin-top: 0;
}

.workflow-accordion-container-modify {
  overflow-y: auto;
  padding: 0 14px 10px 14px;
  position: relative;
  /*height: 300px;*/
  min-height: 330px;
}

.workflow-accordion-container-modify-record {
  overflow-y: auto;
  padding: 0 14px 10px 14px;
  position: relative;
  min-height: 330px;
}

.popup-container {
  min-height: 300px;
  margin-top: 0.75em !important;
  position: absolute !important;
}

#create-record {
  height: 100%;
}

#automated-section .full-width-dialog {
  min-width: 60% !important;
  height: 92vh;
}

#automated-section .workflow-map-fields-container {
  padding: 25px;
  height: calc(100% - 237px);
  overflow-y: auto;
}

.reset-btn {
  display: flex;
  padding-top: 1em;
  padding-left: 0.5em;
}

</style>
<template>
  <!-- Modal -->
  <div class="modal fade automation_action_modal_main" id="create-record-modal" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg-custom full-width-dialog" role="document">
      <div class="modal-content automation_action_modal_content">
        <div class="modal-body workflow-modal-body">
          <div class="tab-pane fade show active" id="create-record" role="tabpanel" aria-labelledby="create-record-tab">
            <div class="border-body-right-top"></div>
            <div class="workflow-create-modal-header">
              <h2>{{ lang.create_record }}</h2>
            </div>
            <div class="workflow-tab-content">
              <div class="workflow-crete-set-field">
                <h2>{{ lang.hint_one_create_record }}</h2>
                <p>{{ lang.hint_two }}</p>
              </div>
            </div>
            <div class="workflow-tab-select-table">
              <p>{{ lang.table }}</p>
              <div class="dropdown workflow-tab-select-down">
                <button class="btn btn-secondary apply-btn-color dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ SelectedTable_label }}
                </button>
                <div class="dropdown-menu workflow-tab-select-down-menu" aria-labelledby="dropdownMenuButton">
                  <div class="popup-search-filter">
                    <input class="form-control table-filter-row-search" v-on:keyup="searchSubmit($event)" type="Search"
                           placeholder="Search..">
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </div>
                  <div class="popup-search-filter-items" id="filterSearchCreate">
                    <p>{{ lang.select_table }}</p>
                    <ul>
                      <li v-for="table in OtherTables" :key="table.id" @click="SelectTableCreate(table)"><a
                          href="javascript:void(0)">{{ table.label }}</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="workflow-map-fields-container">
              <p class="workflow-map-fields-title">{{ lang.map_fields }}</p>
              <div class="workflow-map-fields">
                <div v-for="field in SelectedTable.fields" v-if="field.field_type != 'autonumber'" :key="field.id"
                     class="workflow-map-fields-items">
                  <div class="row">
                    <div class="col-md-3 d-flex justify-content-end"
                         :class="checkActiveDD(field.label) ? 'align-items-center' : ''">
                      <div class="map-fields-name-action">
                        {{ field.label }} <sup v-if="field.is_required">*</sup>
                      </div>
                    </div>
                    <div class="col-auto d-flex align-items-center">
                      <div class="dropdown action-tab-select-down d-flex align-items-center" v-if="fieldTypeOf(field)">
                        <input
                            class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                            type="button"
                            v-bind:value="selectedValues[field.id]"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            v-on:click.stop.prevent="openAccordion(field.label)"
                            v-bind:class="{ 'is-invalid-popup': create_record_error[field.name] == true  }"
                        />

                        <div class="popup-container-main" v-if="checkActiveDD(field.label)"
                             :id="'popup-container-main-'+level">
                          <div class="popup-container popup-container-modify">
                            <div class="popup-search-filter">
                              <div class="workflow-selected-field">
                                <span>{{ lang.select + ' ' + lang.value }}</span>
                              </div>
                            </div>
                            <div class="workflow-accordion-container-modify-record" v-click-outside="outside">
                              <AccordionForCreateRecord
                                  :level="level"
                                  :table="MainTable.label"
                                  :fields="MainTable.fields"
                                  :users="UserTable"
                                  :mapping_for="field"
                                  :custom="true"
                                  :lang="lang"
                                  :field_type="field.field_type"
                                  :SelectedTableExcludedColumnList="SelectedTableExcludedColumnList"
                                  v-on:CreateRecordOptionSelectedEvent="CreateRecordOptionSelected"
                                  :CreateRecordMapping="MappingData"
                                  :executeHandler="executeHandler"
                              ></AccordionForCreateRecord>
                            </div>
                          </div>
                        </div>
                        <div class="reset-btn">
                          <button
                              class="close close-custom"
                              v-if="hasSelectedData(MappingData,field) && fieldTypeOf(field)"
                              @click="removeSelectedItem(MappingData,field)"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>

                      <div v-else>
                        <dateTimePickerCreateRecord
                            :level="level"
                            :mapping_for="field"
                            :custom="true"
                            :field_type="field.field_type"
                            :type="field.type"
                            :Auth="Auth"
                            :lang="lang"
                            :actionType="'create_record'"
                            v-on:CreateRecordOptionSelectedEvent="CreateRecordOptionSelected"
                            v-on:removeSelectedItemEvent="removeSelectedItem(MappingData, field)"
                            :CreateRecordMapping="MappingData"
                            v-bind:class="{ 'is-invalid-popup': create_record_error[field.name] == true  }"
                        ></dateTimePickerCreateRecord>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default apply-btn-color wf-modal-cancel" data-dismiss="modal">
            {{ lang.cancel }}
          </button>
          <button type="button" class="btn btn-primary apply-btn-color wf-modal-save" @click="SaveAction()">{{
              lang.save
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import dateTimePickerCreateRecord from './dateTimePickerCreateRecord.vue';

export default {
  name: 'CreateRecordModal',
  props: [
    'SelectedTableId',
    'whenshould',
    'entity_id',
    'url',
    'level',
    'data_status',
    'Auth',
    'lang',
    'SelectedTableExcludedColumnList',
  ],
  components: {
    // Pixel
  },
  data() {
    return {
      SelectedTable: [],
      UserTable: [],
      executeHandler: null,
      // fields for mapping the values
      MapFieldsCreate: null,

      //Mapping Data
      MappingData: [],
      OtherTables: [],
      Data: [],
      SelectedTable_label: this.lang.select_table,
      MainTable: [],
      ActiveAccordion: [],
      selectedValues: [],
      ExceptionFieldType: ['date', 'datetime', 'dateDynamic', 'datetimeDynamic'],
      DataStatus: this.data_status,

      create_record: null,
      create_record_error: null,
    }
  },
  mounted() {
    this.GetContactTableData();
  },
  watch: {
    whenshould() {
      this.executeHandler = this.whenshould;
    }
  },
  methods: {

    hasSelectedData(mappingData, field) {
      let _index = mappingData.findIndex(x => x.mapping_for_id == field.id);

      if (_index > -1) {
        return true;
      }

      return false;
    },
    removeSelectedItem(mappingData, field) {
      let _index = mappingData.findIndex(x => x.mapping_for_id == field.id);

      if (_index > -1) {
        mappingData.splice(_index, 1);
      }

      if (this.create_record) {
        for (let x in this.create_record) {
          if (x == field.name) {
            this.create_record[x].value = null;
          }
        }
      }
      this.buildSelectedLabels();
    },

    LoadDefaults(action_id, _data = null, _data_status = null) {

      // Get saved data from db for edit action modal
      if (status != null) {
        this.DataStatus = _data_status;
      } else {
        this.DataStatus = null;
      }

      if (_data == null) {
        axios.post('/get-data-for-edit-modal', {'action_id': action_id}).then(response => {
          if (response.data.success) {
            this.SelectedTable = response.data.result.action_map.create_record.selected_table;
            this.MapFieldsCreate = response.data.result.action_map.create_record.selected_table_mapping;
            this.MappingData = response.data.result.action_map.create_record.mapping_data;
            this.GetSelectedTableData();
            this.buildSelectedLabels(this.SelectedTable.fields);
            this.Data = response.data.result;

            this.GenerateDynamicCreate();
          }
        });
      } else {
        this.SelectedTable = _data.create_record.selected_table;
        this.MapFieldsCreate = _data.create_record.selected_table_mapping;
        this.MappingData = _data.create_record.mapping_data;
        this.GetSelectedTableData();
        this.buildSelectedLabels(this.SelectedTable.fields);
        this.Data = _data;
        this.GenerateDynamicCreate();
      }

      this.GetDataApartFromSelectedTable();
    },
    GenerateDynamicCreate() {
      if (this.SelectedTable) {
        if (this.SelectedTable.fields) {
          let create_record = {};
          for (let x in this.SelectedTable.fields) {
            if (this.MappingData) {

              let _index = this.MappingData.findIndex(y => y.mapping_for_name == this.SelectedTable.fields[x].name);

              if (_index > -1) {
                create_record[this.SelectedTable.fields[x].name] = {
                  value: this.MappingData[_index].mapped_with_name,
                };
              } else {
                create_record[this.SelectedTable.fields[x].name] = {
                  value: null,
                };
              }
            }
          }
          this.create_record = create_record;

          let create_record_error = {};
          for (let x in this.SelectedTable.fields) {
            create_record_error[this.SelectedTable.fields[x].name] = false;
          }
          this.create_record_error = create_record_error;
        }

      }

    },
    GetContactTableData() {
      axios.post('/contact-table-data').then(response => {
        if (response.data.success) {
          this.UserTable = response.data.result;
        }
      });
    },
    GetSelectedTableLabel() {
      let _index = this.OtherTables.findIndex(x => x.id == this.SelectedTable.id);
      if (_index > -1) {
        this.SelectedTable_label = this.OtherTables[_index].label;
      }
    },
    SelectMapField(field_id, field_dd, field_name = null) {
      this.$set(this.MappingData, field_name, this.MainTable.name + "." + field_dd.name);
      // this.MappingData[field_name] = this.MainTable.name + "." + field_dd.name;
      document.getElementById('mapFieldCreate-' + field_id).value = this.MainTable.name + "." + field_dd.name;
    },
    searchSubmit(event) {
      let keyword = event.target.value.toLowerCase();
      $("#filterSearchCreate *").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(keyword) > -1);
      });
    },
    SaveAction() {
      let create_flag = 0;

      for (let error in this.create_record) {
        this.create_record_error[error] = false;
      }

      if ((create_flag == 0)) {
        for (let error in this.create_record) {
          this.create_record_error[error] = false;
        }
        this.SaveActionAfterValidation();
      }
    },
    SaveActionAfterValidation() {
      let data = {};

      if (this.DataStatus == "saved") {

        for (let x in this.MappingData) {
          if (this.MappingData[x].field_type_dd == "datetime" ||
              this.MappingData[x].field_type_dd == "date") {
            this.MappingData[x]['isEdit'] = true;
          }
        }

        data = {
          action_id: this.Data.id,
          create_record: {
            create_record: {
              selected_table: this.SelectedTable,
              selected_table_mapping: this.MapFieldsCreate,
              mapping_data: this.MappingData,
            },
            level: this.Data.level
          }
        };
      } else {
        data = {
          action_id: this.Data.id,
          create_record: {
            create_record: {
              selected_table: this.SelectedTable,
              selected_table_mapping: this.MapFieldsCreate,
              mapping_data: this.MappingData,
            },
            level: this.Data.level
          }
        };
      }
      $('#create-record-modal').modal('hide');

      this.$emit('UpdateCreateRecordActionEvent', data);
    },
    requiredFieldToScroll(divClass, action, field_label) {

      // this.$awn.alert(this.lang.required+' '+field_label+' '+this.lang.field_not_set,{
      //     labels : {
      //       alert: this.lang.failed,
      //     }
      // });

      toastr.error(this.lang.required + ' ' + field_label + ' ' + this.lang.field_not_set, this.lang.failed);

      var focusOnDiv = document.querySelector('#create-record-modal .modal-body #' + action + '-record .workflow-map-fields-container .' + action + '-record-' + divClass);

      focusOnDiv.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    },
    containsKey(obj, key) {
      var isExist;
      isExist = Object.keys(obj).includes(key);
      if (isExist) {
        if (obj[key]) {
          return obj[key];
        } else {
          return this.lang.select + ' ' + this.lang.value;
        }
      } else {
        return this.lang.select + ' ' + this.lang.value;
      }
    },
    // get all tables apart from selected table
    GetDataApartFromSelectedTable() {
      axios.post('/non-selected-table', {'table_id': this.SelectedTableId}).then(response => {
        if (response.data.success) {
          this.OtherTables = response.data.result;
          this.GetSelectedTableLabel();
        }
      });
    },
    // get the values of the present table
    GetSelectedTableData() {
      axios.post('/selected-table', {'table_id': this.SelectedTableId}).then(response => {
        if (response.data.success) {
          this.MainTable = response.data.result;
        }
      });
    },
    SelectTableCreate(table) {
      this.SelectedTable_label = table.label;
      this.SelectedTable = table;
      this.MappingData = [];
      this.buildSelectedLabels(table.fields);
    },
    checkActiveDD(field) {
      var _index = this.ActiveAccordion.findIndex(x => x == field);
      if (_index != -1) {
        return true;
      } else {
        return false;
      }
    },
    openAccordion(label) {
      var _index = this.ActiveAccordion.findIndex(x => x == label);
      if (_index == -1) {
        this.ActiveAccordion = [];
        this.ActiveAccordion.push(label);
      } else {
        this.ActiveAccordion = [];
      }
    },
    outside() {
      this.ActiveAccordion = [];
    },
    buildSelectedLabels(fields = null) {
      if (!fields) {
        fields = this.SelectedTable.fields;
      }
      fields.map((field) => {
        this.selectedValues[field.id] = this.InitLabelForCreate(field);
      });
      this.$forceUpdate();
    },
    InitLabelForCreate(field) {
      if (this.MappingData.length != 0) {
        let _index = this.MappingData.findIndex(x => x.mapping_for_id == field.id);
        if (_index > -1) {
          if (this.MappingData[_index].record_type == 'custom') {
            if (Array.isArray(this.MappingData[_index].mapped_with_name)) {
              let val = '';
              for (let i = 0; i < this.MappingData[_index].mapped_with_name.length; i++) {
                val += this.MappingData[_index].mapped_with_name[i] + ',';
              }
              return val.replace(/,\s*$/, '');
            } else {
              return this.MappingData[_index].mapped_with_name;
            }
          } else if (this.MappingData[_index].record_type == 'user') {
            if (Array.isArray(this.MappingData[_index].mapped_with_name)) {
              let val = '';
              for (let i = 0; i < this.MappingData[_index].mapped_with_name.length; i++) {
                val += this.MappingData[_index].mapped_with_name[i] + ',';
              }
              return val.replace(/,\s*$/, '');
            } else {
              return this.MappingData[_index].mapped_with_name;
            }
          } else {
            if (this.MainTable.length != 0) {
              let _selected_field_index = -1;

              _selected_field_index = this.MainTable.fields.findIndex(x => x.id == this.MappingData[_index].mapped_with_id);

              if (this.MappingData[_index].record_type == 'new') {

                if (this.MappingData[_index].field_type_dd == 'relationship') {
                  _selected_field_index = this.SelectedTableExcludedColumnList.findIndex(x => x.id == this.MappingData[_index].mapped_with_id);
                  return this.SelectedTableExcludedColumnList[_selected_field_index].label;
                }

                return this.MainTable.fields[_selected_field_index].label;

              } else {

                if (this.MappingData[_index].field_type_dd == 'relationship') {
                  _selected_field_index = this.SelectedTableExcludedColumnList.findIndex(x => x.id == this.MappingData[_index].mapped_with_id);
                  return this.lang.old + ' ' + this.lang.record + '.' + this.SelectedTableExcludedColumnList[_selected_field_index].label;
                }

                return this.lang.old + ' ' + this.lang.record + '.' + this.MainTable.fields[_selected_field_index].label;
              }
            } else {
              return this.lang.select + ' ' + this.lang.value;
            }
          }
        } else {
          return this.lang.select + ' ' + this.lang.value;
        }
      } else {
        return this.lang.select + ' ' + this.lang.value;
      }

    },
    CreateRecordOptionSelected(data) {
      // remove the old value if exists
      if (
          data.mapping_for.field_type === 'multiselect' ||
          data.mapping_for.field_type === 'multipleselect' ||
          (data.selected_field && data.selected_field.field_type_dd && data.selected_field.field_type_dd === 'multiselect')
      ) {
        this.ManipulationMultiSelectCreatedRecord(this.MappingData, data);
        this.buildSelectedLabels()
        return;
      } else {
        let _index = this.MappingData.findIndex(x =>
            x.mapping_for_id == data.mapping_for.id
        );
        if (_index > -1) {
          this.MappingData.splice(_index, 1);
        }
      }

      let field_type_dd = null;

      if (data.selected_field.field_type_dd != undefined) {
        field_type_dd = data.selected_field.field_type_dd;
      }

      for (let x in this.create_record) {
        if (x == data.mapping_for.name) {
          this.create_record[x].value = data.selected_field.name;
        }
      }

      if (data.selected_field.name !== undefined) {
        this.MappingData.push({
          mapping_for_id: data.mapping_for.id,
          mapping_for_name: data.mapping_for.name,
          mapped_with_id: data.selected_field.id,
          mapped_with_name: data.selected_field.name,
          record_type: data.record_type,
          field_type_dd: field_type_dd,
        });
      }

      this.ActiveAccordion = [];
      this.buildSelectedLabels()
    },
    fieldTypeOf(FieldType) {

      let isIncludeSelctedField = this.ExceptionFieldType.includes(FieldType.type);

      if (isIncludeSelctedField) {
        return false;
      }

      return true;
    },
    ManipulationMultiSelectCreatedRecord(CreatedRecord, data) {

      let outer_index = CreatedRecord.findIndex(x =>
          x.mapping_for_id == data.mapping_for.id
      );

      if (outer_index > -1) {

        let inner_index = CreatedRecord[outer_index].mapped_with_name.indexOf(data.selected_field.name);

        if (inner_index > -1) {
          CreatedRecord[outer_index].mapped_with_name.splice(inner_index, 1);
          CreatedRecord[outer_index].mapped_with_id.splice(inner_index, 1);

          if (CreatedRecord[outer_index].mapped_with_name.length == 0) {
            CreatedRecord.splice(outer_index, 1);
          }

        } else {
          CreatedRecord[outer_index].mapped_with_name.push(data.selected_field.name);
          CreatedRecord[outer_index].mapped_with_id.push(data.selected_field.id);
        }

      } else {

        let field_type_dd = null;

        if (data.selected_field.field_type_dd != undefined) {
          field_type_dd = data.selected_field.field_type_dd;
        }

        CreatedRecord.push({
          mapping_for_id: data.mapping_for.id,
          mapping_for_name: data.mapping_for.name,
          mapped_with_id: [data.selected_field.id],
          mapped_with_name: [data.selected_field.name],
          record_type: data.record_type,
          field_type_dd: field_type_dd,
        });
      }
    }
  }

}
</script>
